import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";

import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import IconButton from "@mui/material/IconButton";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chart from "react-apexcharts";

import AssetViewModal from "../../../Components/Modal/AssetViewModal";
import {
  getAssignmentWiseClassData,
  getAssignmentWiseHeatmapData,
  getUserLogs,
} from "../Services";
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

// import _ from 'lodash';

const HeatmapList = () => {
  // Hooks
  const styles = useStyles();
  const dispatch = useDispatch();
  const navigation = useNavigate();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);

  //State
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedClassName, setSelectedClassName] = useState(null);

  const [dataSeries, setDataSeries] = useState([]);
  const [attemptedLearners, setAttemptedLearners] = useState(0);
  const [averageScore, setAverageScore] = useState(0);
  const [dynamicHeight, setDynamicHeight] = useState(0);
  const [chartOptions, setChartOptions] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [questionAttempts, setQuestionAttempts] = useState(null);
  const [questionJsonData, setQuestionJsonData] = useState(null);

  const [stateSnackbar, setStateSnackbar] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = stateSnackbar;

  // React logic hooks
  useEffect(() => {
    console.log("HeatmapList===>", paramsdata);
    const getInitialData = async () => {
      let params = {
        query: {
          learners: paramsdata.reportData.learners.learners,
          site_uuid: userInfo.site_uuid,
        },
      };
      let res = await getAssignmentWiseClassData(null, params);
      console.log("res.classesList=====>", res.classesList);
      setClasses(res.classesList);
    };
    getInitialData();
  }, [paramsdata, userInfo]);

  useEffect(() => {
    //console.log("paramsdata selectedClass====>", paramsdata.selectedClass);
    if (classes && paramsdata.selectedClass !== undefined) {
      let classObj = classes.find((classData) => {
        return classData.value == paramsdata.selectedClass;
      });
      if (classObj) {
        return handleClassChange(classObj);
      }
    }
  }, [classes, paramsdata.selectedClass]);

  useEffect(() => {
    console.log("selectedClass====>", selectedClass);
    if (selectedClass != null) {
      const getHeatmapData = async () => {
        let params = {
          query: {
            assignmentId: paramsdata.reportData.uid,
            classId: selectedClass,
            learners: paramsdata.reportData.learners.learners,
            tasks: paramsdata.reportData.tasks.tasks,
            site_uuid: userInfo.site_uuid,
          },
        };
        let res = await getAssignmentWiseHeatmapData(params);
        console.log("finalData=====>", res.finalData);
        setDataSeries(res.finalData);
      };
      getHeatmapData();
    }
  }, [selectedClass, paramsdata, userInfo]);

  const redirect = (assetId) => {
    console.log("assetId=====>", assetId);
    console.log("paramsdata.selectedClass", selectedClass);

    dispatch(
      commonSliceActions.setParamsData({
        ...paramsdata,
        selectedClass: selectedClass,
      })
    );
    navigation(`/Report/LearnerContent/${assetId}`);
  };

  useEffect(() => {
    if (dataSeries.length > 0) {
      let attemptLearners = 0;
      let avgScore = 0;
      let quewiseAvg = {
        name: "Average",
        extra: "",
        data: [],
      };
      for (let x = 0; x < dataSeries.length; x++) {
        let studentAvgScore = 0;
        let attempted = false;
        for (let qu = 0; qu < dataSeries[x]["data"].length; qu++) {
          if (x == 0) {
            quewiseAvg["data"].push({
              x: "",
              y: 0,
              extra: "",
            });
          }
          quewiseAvg["data"][qu]["extra"] = dataSeries[x]["data"][qu]["extra"];
          quewiseAvg["data"][qu]["x"] = dataSeries[x]["data"][qu]["x"];
          if (+dataSeries[x]["data"][qu]["y"] != -1) {
            studentAvgScore += +dataSeries[x]["data"][qu]["y"];
            quewiseAvg["data"][qu]["y"] += +dataSeries[x]["data"][qu]["y"];
            if (!attempted) {
              attemptLearners++;
              attempted = true;
            }
          }
        }
        studentAvgScore = studentAvgScore / dataSeries[x]["data"].length;
        avgScore += studentAvgScore;
      }
      setAttemptedLearners(attemptLearners);
      setAverageScore(avgScore);
      for (let qu = 0; qu < quewiseAvg["data"].length; qu++) {
        quewiseAvg["data"][qu]["y"] = Math.round(
          +quewiseAvg["data"][qu]["y"] / dataSeries.length
        );
      }
      dataSeries.push(quewiseAvg);

      console.log("dataSeries", dataSeries);
      console.log("avgScore", avgScore);

      setDynamicHeight(dataSeries.length * 20 + 200);
      let obj = {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: async (event, chartContext, config) => {
              if (event.which == 3) {
                // console.log("!!!!!!!!!!chartContext", chartContext);
                // console.log("!!!!!!!!!!config", config);
                // console.log("!!!!!!!dataSeries", dataSeries[0]['data'][config.dataPointIndex]['x']);
                // console.log("!!!!!dataSeries extra", dataSeries[0]['data'][config.dataPointIndex]['extra']);
                // navigation('/Report/LearnerContent/'+);

                redirect(dataSeries[0]["data"][config.dataPointIndex]["extra"]);
              } else {
                if (config.seriesIndex != dataSeries.length - 1) {
                  let selectedSeries = dataSeries[config.seriesIndex];
                  let params = {
                    query: {
                      verb: "attemptAssignment",
                      target: paramsdata.reportData.uid,
                      context: {
                        assetId:
                          dataSeries[0]["data"][config.dataPointIndex]["extra"],
                      },
                      actor: selectedSeries.extra,
                      $sort: {
                        createdAt: -1,
                      },
                    },
                  };
                  let res = await getUserLogs(params);
                  console.log("@@@@@@@##########res", res);

                  let quesAttempts = res.data.data;
                  setQuestionAttempts(quesAttempts);
                  if (quesAttempts.length > 0) {
                    setQuestionJsonData({
                      studentname: selectedSeries.name,
                      question:
                        dataSeries[0]["data"][config.dataPointIndex]["x"],
                    });
                    setModalVisible(true);
                  } else {
                    setStateSnackbar({ ...stateSnackbar, open: true });
                    return false;
                  }
                }
              }
            },
            dataPointMouseEnter: (event, chartContext, config) => {
              event.target.style.cursor = "pointer";
            },
            dataPointMouseLeave: (event, chartContext, config) => {
              event.target.style.cursor = "none";
            },
          },
        },
        plotOptions: {
          heatmap: {
            enableShades: false,
            radius: 0,
            useFillColorAsStroke: false,
            colorScale: {
              ranges: [
                {
                  from: 100,
                  to: 100,
                  name: "100%",
                  color: "#EDBB99",
                },
                {
                  from: 67,
                  to: 99,
                  name: "67% to 99%",
                  color: "#E59866",
                },
                {
                  from: 33,
                  to: 66,
                  name: "33% to 66%",
                  color: "#D35400",
                },
                {
                  from: 1,
                  to: 32,
                  name: "1% to 32%",
                  color: "#A04000",
                },
                {
                  from: 0,
                  to: 0,
                  name: "0",
                  color: "#6E2C00",
                },
                {
                  from: -1,
                  to: -1,
                  name: "Not Attempted",
                  color: "#c2c0c0",
                },
              ],
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
            rotate: -45,
            offsetY: -25,
            offsetX: 2,
            hideOverlappingLabels: false,
            showDuplicates: false,
          },
          minHeight: 150,
          axisTicks: {
            offsetY: -5,
          },
          axisBorder: {
            offsetY: 0,
          },
          floating: true,
          position: "top",
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          showAlways: true,
        },
        grid: {
          padding: {
            top: 60,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
          },
          y: {
            formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
              if (value == -1) {
                return "Not Attempted";
              } else {
                return value.toFixed(2) + " %";
              }
            },
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
          onItemClick: {
            toggleDataSeries: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },
        title: {
          text:
            "Assignment : " +
            paramsdata.reportData.title +
            " for Class : " +
            selectedClassName,
          align: "center",
          style: {
            fontSize: "20px",
          },
        },
      };
      setChartOptions(obj);
    }
  }, [dataSeries, paramsdata]);

  const handleClose = () => {
    setStateSnackbar({ ...stateSnackbar, open: false });
  };

  const handleClassChange = (itemData) => {
    setSelectedClass(itemData.value);
    setSelectedClassName(itemData.label);
  };

  const handleDownloadCsv = () => {
    let csv = "";
    csv = "Student Name,";

    for (let q = 0; q < dataSeries[0]["data"].length; q++) {
      csv += "Q" + (q + 1) + ",";
    }

    csv += "Total,Percentage(%)";

    csv += "\n";

    for (let x = 0; x < dataSeries.length; x++) {
      let studentTotalScore = 0;
      csv += dataSeries[x]["name"] + ",";
      for (let qu = 0; qu < dataSeries[x]["data"].length; qu++) {
        if (+dataSeries[x]["data"][qu]["y"] == -1) {
          csv += "NA,";
        } else {
          csv += +dataSeries[x]["data"][qu]["y"] / 100 + ",";
          studentTotalScore += +dataSeries[x]["data"][qu]["y"] / 100;
        }
      }

      csv +=
        studentTotalScore +
        "," +
        ((studentTotalScore / dataSeries[0]["data"].length) * 100).toFixed(2);
      csv += "\n";
    }

    var hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute(
      "download",
      "Class_" +
        selectedClassName +
        "-" +
        paramsdata.reportData.title.split(" ").join("_") +
        "-ClasswiseAssignmentReport.csv"
    );
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mx: 6 }}>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <Grid container spacing={0} sx={{ marginTop: "20px" }}>
              <Grid item xs={9}></Grid>
              <Grid item xs={1}>
                {dataSeries.length > 0 &&
                  process.env.REACT_APP_DOWNLOAD_ALLOW == 'true' && (
                    <List>
                      <ListItem
                        sx={{ mt: 4.5, p: 0, ml: 5 }}
                        secondaryAction={
                          <IconButton
                            color="primary"
                            onClick={() => {
                              handleDownloadCsv();
                            }}
                          >
                            <CloudDownloadIcon sx={{ fontSize: "2vw" }} />
                          </IconButton>
                        }
                      />
                      {/* <IconButton onClick={() => { handleDownloadCsv() }} aria-label="comment" color="primary">
                                                <ArrowDownwardIcon sx={{ fontSize: '2vw' }} />
                                            </IconButton> */}
                    </List>
                  )}
              </Grid>
              <Grid item xs={2} sx={{ px: 4 }}>
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          px: 1,
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#DB8829",
                          "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                        }}
                      >
                        Select Classes
                      </Typography>
                    }
                  />
                  <Select
                    value={selectedClass}
                    sx={{
                      borderRadius: 20,
                      borderColor: "#DB8829",
                      width: "15ch",
                      color: "#DB8829",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                        width: "20ch",
                        mt: 0.5,
                      },
                    }}
                    // onChange={handleClassChange}
                  >
                    {classes.map((itemData, index) => (
                      <MenuItem
                        sx={{
                          color: "#DB8829",
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                        }}
                        key={`${index}_Class`}
                        value={itemData.value}
                        onClick={() => {
                          handleClassChange(itemData);
                        }}
                      >
                        {itemData.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={0} sx={{ marginTop: "20px" }}>
              <Grid item xs={2}></Grid>
              {dataSeries.length > 0 && (
                <Grid item xs={8}>
                  <Grid container spacing={2} sx={{}}>
                    <Grid item xs={6}>
                      <List sx={{ p: 0, m: 0 }}>
                        <ListItem
                          sx={{ borderRadius: 15, border: "1px solid #e0e0e0" }}
                        >
                          <Grid container spacing={0} sx={{}}>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    Total Learner
                                  </Typography>
                                }
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      color: "#DB8829",
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    : {dataSeries.length - 1}{" "}
                                  </Typography>
                                }
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item xs={6}>
                      <List sx={{ p: 0, m: 0 }}>
                        <ListItem
                          sx={{ borderRadius: 15, border: "1px solid #e0e0e0" }}
                        >
                          <Grid container spacing={0} sx={{}}>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      color: "#DB8829",
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    Attempted
                                  </Typography>
                                }
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    : {attemptedLearners}{" "}
                                  </Typography>
                                }
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item xs={6}>
                      <List sx={{ p: 0, m: 0, pb: 3 }}>
                        <ListItem
                          sx={{ borderRadius: 15, border: "1px solid #e0e0e0" }}
                        >
                          <Grid container spacing={0} sx={{}}>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    Not Attempted
                                  </Typography>
                                }
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    :{" "}
                                    {dataSeries.length - 1 - attemptedLearners}
                                  </Typography>
                                }
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item xs={6}>
                      <List sx={{ p: 0, m: 0, pb: 3 }}>
                        <ListItem
                          sx={{ borderRadius: 15, border: "1px solid #e0e0e0" }}
                        >
                          <Grid container spacing={0} sx={{}}>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    Average Score
                                  </Typography>
                                }
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ListItemText
                                sx={{ m: 0, px: 0, py: 0.3 }}
                                primary={
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      color: "#DB8829",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    :{" "}
                                    {(
                                      averageScore /
                                      (dataSeries.length - 1)
                                    ).toFixed(2)}
                                    %{" "}
                                  </Typography>
                                }
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid container>
              <Grid item xs={12} className={styles.scrollBarHeight}>
                {chartOptions && (
                  <Chart
                    type="heatmap"
                    height={dynamicHeight}
                    options={chartOptions}
                    series={dataSeries}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <AssetViewModal
        show={modalVisible}
        toggleModal={(flag) => setModalVisible(flag)}
        questionAttempts={questionAttempts}
        questionJsonData={questionJsonData}
        persistent={false}
        selectedClass={selectedClass}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={6000}
        open={open}
        onClose={handleClose}
        message="Question not attempted!"
        key={vertical + horizontal}
        ContentProps={{
          classes: {
            root: styles.root,
          },
        }}
      />
    </>
  );
};
const useStyles = makeStyles({
  root: {
    backgroundColor: "#00cc4e",
    color: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "110%",
    fontWeight: "600",
  },
  roundbutton: {
    height: "1.3em !important",
    minWidth: "20px !important",
    maxWidth: "20px !important",
    border: "solid 1px red",
    borderRadius: "50%",
    float: "left",
    background: "red",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "55vh",
    overflow: "auto",
  },
});
export default HeatmapList;
